import type { IconData } from '@stacksjs/iconify-core'

export const swapVertical: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M384 433.373V160h-32v274.51l-69.823-69.823l-22.627 22.626l107.882 107.883l107.881-107.883l-22.626-22.626zM159.432 17.372L51.55 125.255l22.627 22.627L144 78.059V352h32V79.195l68.687 68.687l22.626-22.627z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default swapVertical
